/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_File_Deleted_SuccessInputs */

const en_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation file deleted successfully`)
};

const fr_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de traduction supprimé avec succès`)
};

const de_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsdatei erfolgreich gelöscht`)
};

const it_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File di traduzione eliminato con successo`)
};

const ru_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл перевода успешно удален.`)
};

const es_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de traducción eliminado correctamente`)
};

const zh_cn2_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译文件已成功删除`)
};

const ja_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳ファイルが正常に削除されました`)
};

const hi_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद फ़ाइल सफलतापूर्वक हटा दी गई`)
};

const pt_pt2_translation_file_deleted_success = /** @type {(inputs: Translation_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de tradução excluído com sucesso`)
};

/**
* | output |
* | --- |
* | "Translation file deleted successfully" |
*
* @param {Translation_File_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_file_deleted_success = /** @type {((inputs?: Translation_File_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_File_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_file_deleted_success(inputs)
	if (locale === "de") return de_translation_file_deleted_success(inputs)
	if (locale === "it") return it_translation_file_deleted_success(inputs)
	if (locale === "ru") return ru_translation_file_deleted_success(inputs)
	if (locale === "es") return es_translation_file_deleted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_file_deleted_success(inputs)
	if (locale === "ja") return ja_translation_file_deleted_success(inputs)
	if (locale === "hi") return hi_translation_file_deleted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_file_deleted_success(inputs)
	return en_translation_file_deleted_success(inputs)
});